import React from 'react';
import './index.less';

import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';

import withIntl from '../../../../shared/intl-hoc';

function AllPromos({ intl, promos, apply, locationsLookups }) {
	return (
		<div className='offers-info-promos'>
			<SearchForm
				locationsLookups={locationsLookups}
				intl={intl}
				onSubmit={apply}
			/>
			<div className='offers-info-promos-title'>
				{intl('Landings:')}
			</div>
			<div className='offers-info-promos-list'>
				{promos.landings.map((landing) => (
					<a href={`http://${landing}`} target='_blank' key={landing}>
						{landing}
					</a>
				))}
			</div>
			<div className='offers-info-promos-title'>
				{intl('Transits:')}
			</div>
			<div className='offers-info-promos-list'>
				{promos.transits.map((transit) => (
					<a href={`http://${transit}`} target='_blank' key={transit}>
						{transit}
					</a>
				))}
			</div>
		</div>
	);
}

const SearchForm = reduxForm({ form: 'promosFiltersForm', enableReinitialize: true })((props) => (
	<div className="width-300">
		<Field
			name="countries"
			placeholder={props.intl('Location')}
			onChange={() => props.submit()}
			component={SelectField}
			multi={true}
			showLabel={true}
			searchable={true}
			options={props.locationsLookups}
		/>
	</div>
));

export default withIntl(AllPromos);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/AllPromos/index.js